import { observable, action, makeObservable, runInAction } from 'mobx'

import { removeBlock } from '@client/components/Sidebar/SidebarDefault/TabBuild/CustomBlocks/model'

export class RemoveBlockDialogModel {
  @observable show = false
  @observable saved = false
  @observable error = false
  @observable saving = false
  @observable block = null

  constructor() {
    makeObservable(this)
  }

  @action showDialog = (block) => {
    this.show = true
    this.saved = false
    this.error = false
    this.saving = false
    this.block = block
  }

  @action setSaved = (saved) => {
    this.saved = saved
  }

  @action setError = (error) => {
    this.error = error
  }

  // A failed delete keeps the dialog's confirmation, with the error, so the
  // user can retry (FE-1489). It used to be shown as a success.
  @action remove = async () => {
    this.saving = true
    this.setError(false)

    if (this.block) {
      try {
        await removeBlock(this.block.id)
        this.setSaved(true)
      } catch (e) {
        this.setError(true)
      }
    }

    runInAction(() => {
      this.saving = false
    })
  }

  @action hideDialog = () => {
    this.show = false
    this.saved = false
    this.error = false
    this.saving = false
    this.block = null
  }
}

export const removeBlockDialogModel = new RemoveBlockDialogModel()
export const showDialog = removeBlockDialogModel.showDialog
export const hideDialog = removeBlockDialogModel.hideDialog
